import { StaticFormFieldMappings } from '../../../service-request-form-response.mapper.util';
import { CI_QUESTION_ID_CONTROL_KEYS } from './ci-form.fields';

const CI_SPECIFIC_MAPPINGS: StaticFormFieldMappings = Object.fromEntries(
  CI_QUESTION_ID_CONTROL_KEYS.map((controlKey, index) => [controlKey, 99001 + index]),
);

export const CI_STATIC_FIELD_MAPPINGS: StaticFormFieldMappings = {
  ...CI_SPECIFIC_MAPPINGS,
};
